//Importaciones Externas y servicios
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Card, Col, Container, Row } from "react-bootstrap";
import { paginadorAlertasStore, paginadoRecorridosStore } from '../../../lib/store/paginador_store';
import reporteTiempoStore from "../../../lib/store/reporte_tiempo_store";
import dayjs from 'dayjs';
import { obtenerIconoEvento } from '../../../components/common/google-maps-selector/IconosTabla';
import PrintReportModule from '../../../components/print/PrintReportModule';
import { cargarPaginasUltraOptimizado } from '../../../providers/provider_paginado';
import FiltersNonWorkingHours from './filters.js';
import {
    EmptyState,
    WelcomeEmptyState,
    LoadingEmptyState,
    NoDataEmptyState,
    NoSelectionEmptyState,
    ProgressBarWithComponents,
    AlertError,
    APIError,
    ValidationError
} from '../../../components/common/progressemptystate.js';
import { iconAlerta, iconAlertaDetenido, iconDetenido, iconMotorApagado, iconMotorEncendido, iconPunto, iconPuntoF, iconPuntoI, obtenerInfoView, obtenerInfoViewTop } from '../../../components/common/google-maps-selector/GoogleMapSelector';
import StandardProgressBar from '../../../components/common/ProgressBar/StandardProgressBar';
import TableNonWorkingHours from './components/table-report/table-hours.js';
import CardVehiclesOutHour from './components/card-vehicles/vehicles-out-hour.js';

//Variables globales 
const adTipos = ["17", "18"];
const eTipos = ["4", "6"];
const aTipos = ["3", "5"];
const dTipos = ["11", "12", "17", "18", "30"];

/******************************************************* 
 ********* Reporte Horario No Laboral ******************
********************************************************/

const ReporteHorarioNoLaboral = () => {

    /******** Estados del modulo ***********************/
    const store = reporteTiempoStore();
    const paginadorRecorridos = paginadoRecorridosStore();
    const paginadorAlertas = paginadorAlertasStore();
    const [alertasRecorrido, editarAlertasRecorrido] = useState([]);
    const [filtrosLocal, editarFiltrosLocal] = useState(null);
    const [totalCarga, editarTotalCarga] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [geocercas, setGeocercas] = useState([]);
    const PER_PAGE = 100;
    const [perPage, setPerPage] = useState(PER_PAGE);
    const [maxProgress, setMaxProgress] = useState(0);

    const [apiError, setApiError] = useState(null);
    const [validationError, setValidationError] = useState(null);
    const [searchInitiated, setSearchInitiated] = useState(false);
    const [showDebugPanel, setShowDebugPanel] = useState(true); // ✅ Cambiar a true
    const [selectedVehicle, setSelectedVehicle] = useState(null);

    const [loadingComponents, setLoadingComponents] = useState({
        table: { loading: false, progress: 0, complete: false },
        vehicles: { loading: false, progress: 0, complete: false },
        alerts: { loading: false, progress: 0, complete: false }, // ✅ DESCOMENTAR
    });

    const [debugMetrics, setDebugMetrics] = useState({
        searchStartTime: null,
        searchEndTime: null,

        connections: {
            'RecorridosUsabilidad': {
                name: 'Recorridos (GPS)',
                startTime: null,
                endTime: null,
                totalRecordsExpected: 0,
                totalRecordsReceived: 0,
                totalApiCalls: 0,
                completedApiCalls: 0,
                failedApiCalls: 0,
                recoveredApiCalls: 0,
                apiCallsHistory: [],
                downloadProgress: 0,
                status: 'pending'
            },
            'AlertasUsabilidad': {
                name: 'Alertas (GPS)',
                startTime: null,
                endTime: null,
                totalRecordsExpected: 0,
                totalRecordsReceived: 0,
                totalApiCalls: 0,
                completedApiCalls: 0,
                failedApiCalls: 0,
                recoveredApiCalls: 0,
                apiCallsHistory: [],
                downloadProgress: 0,
                status: 'pending'
            }
        },

        globalTotalRecordsExpected: 0,
        globalTotalRecordsReceived: 0,
        globalDownloadProgress: 0,
        activeConnections: 0,


        componentTimes: {
            table: { start: null, end: null },
            vehicles: { start: null, end: null },
            alerts: { start: null, end: null },
        }
    });

    /******** Variables locales del modulo ***************************************/
    let diff = store.fechaFin - store.fechaInicio;
    let horas = parseFloat((diff / (1000 * 60 * 60)));
    let ApiRecorridos = process.env.REACT_APP_VEHICLE_LOCATIONS_URL;
    let connectionId = 'RecorridosUsabilidad';
    let apialertas = `${process.env.REACT_APP_ALERTS_API_URL}/alerts`;
    let conectionidalertas = 'AlertasUsabilidad';

    /******** ÍNDICES MEMORIZADOS PARA OPTIMIZACIÓN ******************************/
    const vehiculosIndexados = useMemo(() => {
        return store.vehiculos.reduce((acc, vehiculo) => {
            acc[vehiculo.value] = vehiculo;
            return acc;
        }, {});
    }, [store.vehiculos]);

    const alertasPorVehiculo = useMemo(() => {

        return alertasRecorrido.reduce((acc, alerta) => {
            const uid = alerta.uid_vehiculo;
            if (!acc[uid]) acc[uid] = [];
            acc[uid].push(alerta);
            return acc;
        }, {});
    }, [alertasRecorrido]);

    const alertasIndexadas = useMemo(() => {

        return store.alertas.reduce((acc, alerta) => {
            const nombre = alerta?.nombre?.toLowerCase();
            if (nombre) {
                acc[nombre] = alerta;
            }
            return acc;
        }, {});
    }, [store.alertas]);

    //Crea indices de datos de recorridos
    const indicesDatos = useMemo(() => {
        if (!paginadorRecorridos.datos.length) return { porVehiculo: {}, ordenados: [] };

        // console.log('🔄 Creando índices de datos de recorridos...');
        const porVehiculo = {};
        const ordenados = [];

        paginadorRecorridos.datos.forEach((ubicacion, index) => {
            const vehiculoId = ubicacion.vehiculoUid;
            const fechaTime = new Date(ubicacion.fecha).getTime();

            const item = {
                ...ubicacion,
                fechaTime,
                index
            };

            // Índice por vehículo
            if (!porVehiculo[vehiculoId]) {
                porVehiculo[vehiculoId] = [];
            }
            porVehiculo[vehiculoId].push(item);

            // Array ordenado por fecha para búsquedas binarias
            ordenados.push(item);
        });

        // Ordenar cada vehículo por fecha
        Object.keys(porVehiculo).forEach(vehiculoId => {
            porVehiculo[vehiculoId].sort((a, b) => a.fechaTime - b.fechaTime);
        });

        return { porVehiculo, ordenados };
    }, [paginadorRecorridos.datos]);

    /****** Eventos (Call Backs) *************************************************/
    const handleSelectVehicle = useCallback((vehicle) => {
        setSelectedVehicle(prevVehicle => prevVehicle === vehicle ? '' : vehicle);
    }, []);

    const handleClearFilters = useCallback(() => {
        setSelectedVehicle('');
    }, []);

    //Calcula el progreso de la busqueda de datos
    const calculateTotalProgress = useCallback(() => {
        const weights = {
            table: 0.4,      // ✅ Ajustar para que sume 100%
            vehicles: 0.3,   // ✅ Solo componentes que existen
            alerts: 0.3,     // ✅ Solo componentes que existen                
        };

        let totalProgress = 0;
        let totalWeight = 0;

        Object.entries(loadingComponents).forEach(([component, state]) => {
            if (state && (state.loading || state.complete)) {
                const progress = Number(state.progress);
                if (!isNaN(progress)) {
                    totalProgress += progress * weights[component];
                    totalWeight += weights[component];
                } else {
                    totalProgress += (state.complete ? 100 : 0) * weights[component];
                    totalWeight += weights[component];
                }
            }
        });

        if (totalWeight === 0) return 0;
        const result = totalProgress / totalWeight;

        return Math.min(Math.max(result, 0), 100);
    }, [loadingComponents]);

    //Eliminar mensajes de error
    const clearErrors = useCallback(() => {
        setApiError(null);
        setValidationError(null);
    }, []);

    //Actializa componente progressbar
    const updateComponentProgress = useCallback((component, progress, isComplete = false) => {
        setLoadingComponents(prevState => {
            const newState = { ...prevState };

            if (newState[component]) {
                newState[component] = {
                    ...newState[component],
                    loading: !isComplete,
                    progress: isComplete ? 100 : Math.max(0, Math.min(100, progress)),
                    complete: isComplete
                };
            }

            return newState;
        });

        // ✅ Actualizar métricas directamente sin dependencia circular
        setDebugMetrics(prev => ({
            ...prev,
            componentTimes: {
                ...prev.componentTimes,
                [component]: {
                    start: !isComplete ? Date.now() : (prev.componentTimes[component]?.start || Date.now()),
                    end: isComplete ? Date.now() : null
                }
            }
        }));
    }, []);

    //Actializa componente progressbar
    const updateDebugMetrics = useCallback((updates) => {
        setDebugMetrics(prev => {
            if (!prev || !prev.connections) {
                console.warn('⚠️ debugMetrics no está inicializado correctamente');
                return prev || {
                    connections: {},
                    globalTotalRecordsExpected: 0,
                    globalTotalRecordsReceived: 0,
                    globalDownloadProgress: 0,
                    activeConnections: 0,
                    componentTimes: {}
                };
            }
            const newState = { ...prev };

            if (updates.connectionId && newState.connections[updates.connectionId]) {
                const connection = newState.connections[updates.connectionId];

                if (!connection.apiCallsHistory) {
                    connection.apiCallsHistory = [];
                }

                // Actualizar datos específicos de la conexión
                Object.keys(updates).forEach(key => {
                    if (key !== 'connectionId') {
                        if (key === 'apiCallsHistory' && Array.isArray(updates[key])) {
                            const newCalls = updates[key].map(call => ({
                                ...call,
                                timestamp: call.timestamp || Date.now()
                            }));
                            connection[key] = [...(connection[key] || []), ...newCalls];

                            if (connection[key].length > 50) {
                                connection[key] = connection[key].slice(-50);
                            }
                        } else if (key !== 'apiCallsHistory') {
                            connection[key] = updates[key];
                        }
                    }
                });

                const activeConnections = Object.values(newState.connections).filter(conn =>
                    conn && (conn.status === 'downloading' || conn.status === 'completed')
                );

                newState.globalTotalRecordsExpected = activeConnections.reduce((sum, conn) =>
                    sum + (conn.totalRecordsExpected || 0), 0
                );

                newState.globalTotalRecordsReceived = activeConnections.reduce((sum, conn) =>
                    sum + (conn.totalRecordsReceived || 0), 0
                );

                newState.globalDownloadProgress = newState.globalTotalRecordsExpected > 0 ?
                    (newState.globalTotalRecordsReceived / newState.globalTotalRecordsExpected * 100) : 0;

                newState.activeConnections = activeConnections.length;

            } else if (updates.connectionId && !newState.connections[updates.connectionId]) {
                newState.connections[updates.connectionId] = {
                    name: updates.connectionId,
                    startTime: null,
                    endTime: null,
                    totalRecordsExpected: 0,
                    totalRecordsReceived: 0,
                    totalApiCalls: 0,
                    completedApiCalls: 0,
                    failedApiCalls: 0,
                    recoveredApiCalls: 0,
                    apiCallsHistory: [],
                    downloadProgress: 0,
                    status: 'pending'
                };

                Object.keys(updates).forEach(key => {
                    if (key !== 'connectionId') {
                        newState.connections[updates.connectionId][key] = updates[key];
                    }
                });

            } else {
                Object.keys(updates).forEach(key => {
                    if (key === 'componentTimes') {
                        if (!newState.componentTimes) {
                            newState.componentTimes = {};
                        }
                        newState.componentTimes = { ...newState.componentTimes, ...updates.componentTimes };
                    } else if (key !== 'connectionId') {
                        newState[key] = updates[key];
                    }
                });
            }

            return newState;
        });

        // ✅ SINCRONIZAR DESCARGA CON BARRA DE PROGRESO
        /*if (updates.connectionId && updates.downloadProgress !== undefined) {
            setTimeout(() => {
                const componentMapping = {
                    'RecorridosUsabilidad': 'vehicles',
                    'AlertasUsabilidad': 'alerts'
                };

                const componentName = componentMapping[updates.connectionId];

                if (componentName) {
                    // ✅ Usar el progreso real de descarga para actualizar el componente
                    const isComplete = updates.downloadProgress >= 100;
                    const progressValue = Math.round(updates.downloadProgress || 0);

                    console.log(`🔄 [Sincronización] ${componentName}: ${progressValue}% (descarga ${isComplete ? 'completa' : 'en progreso'})`);

                    updateComponentProgress(componentName, progressValue, isComplete);

                    // ✅ Si la descarga está completa, también marcar como cargando = false
                    if (isComplete) {
                        setLoadingComponents(prevState => ({
                            ...prevState,
                            [componentName]: {
                                loading: false,
                                progress: 100,
                                complete: false
                            }
                        }));
                    }
                }
            }, 0);
        }*/
    }, [updateComponentProgress]);

    //Evento click boton filtar (prepara los filtros de busqueda)
    const onGenerateReport = async (filtros) => {
        console.log('🚀 [GENERATE] Iniciando generación de reporte...');

        // Validaciones
        if (!filtros.uids_vehiculo || filtros.uids_vehiculo.length === 0) {
            setValidationError('Debe seleccionar al menos un vehículo');
            return;
        }

        // Limpiar errores y marcar búsqueda iniciada
        clearErrors();
        setSearchInitiated(true);

        // Reset completo
        resetearEstadosCompleto();

        await new Promise(resolve => setTimeout(resolve, 200));

        editarFiltrosLocal(filtros);
        setGeocercas(filtros.geocercas);

        const { geocercas, ...restoFiltros } = filtros;
        editarFiltrosLocal(restoFiltros);
    };

    //Valida si no hay filtros seleccionados
    const hasNoFiltersSelected = useCallback(() => {
        return !filtrosLocal ||
            !filtrosLocal.uids_vehiculo ||
            filtrosLocal.uids_vehiculo.length === 0;
    }, [filtrosLocal]);

    //Verifica si la pagina esta cargando datos 
    const isLoadingData = useCallback(() => {
        return paginadorRecorridos.cargando || paginadorAlertas.cargando || Object.values(loadingComponents).some(
            (c) => c.loading
        );
    }, [paginadorRecorridos.cargando, paginadorAlertas.cargando, loadingComponents]);

    //Valida el resultado para verificar si hay datos encontrados
    const hasNoData = useCallback(() => {
        return !isLoadingData() &&
            searchInitiated &&
            (!store.listaTabla || store.listaTabla.length === 0);
    }, [isLoadingData, searchInitiated, store.listaTabla]);

    //Obtiene los marcadores de las alertas para el mapa 
    const obtenerMarcadoresAlertas = useCallback((vehiculoUid) => {
        var index = 0;
        const alertasVehiculo = alertasPorVehiculo[vehiculoUid] || [];
        const vehiculo = vehiculosIndexados[vehiculoUid];

        return alertasVehiculo.filter(g => g.uid_vehiculo === vehiculoUid).map(w => {
            if (w.alerta_real?.includes("Movimiento") || w.tipo_real === 1) return null;
            index += 1;

            return {
                lat: parseFloat(w.latitud),
                lng: parseFloat(w.longitud),
                icon: obtenerIcono(w.tipo_real, w.tipo_alerta),
                radio: w.radio,
                infoViewTop: obtenerInfoViewTop({
                    markerId: index,
                    titulo: vehiculo ? (vehiculo.no_economico + " / " + vehiculo.alias) : '',
                    colorFondoTitulo: w.color || 'black',
                    colorTextoTitulo: 'text-white',
                    velocidad: w.velocidad || '',
                    alerta: w.alerta_real || '',
                    fecha: dayjs(w.fecha).format('DD/MM/YYYY HH:mm:ss') || '',
                    ruta: w.distancia ? (w.distancia).toFixed(3) : 'N/A',
                    chofer: w.chofer || 'N/A'
                })
            };
        });
    }, [alertasPorVehiculo, vehiculosIndexados]); // ✅ Solo cuando cambien los índices

    // ✅ CACHE MEMOIZADO PARA MARCADORES DE ALERTAS - Optimizado para evitar re-renders constantes
    const marcadoresAlertasCache = useMemo(() => {

        const cache = new Map();

        return {
            obtener: (vehiculoUid) => {
                if (!cache.has(vehiculoUid)) {
                    const resultado = obtenerMarcadoresAlertas(vehiculoUid);
                    cache.set(vehiculoUid, resultado);
                }
                return cache.get(vehiculoUid);
            },
            limpiar: () => cache.clear(),
            tamaño: () => cache.size
        };
    }, [obtenerMarcadoresAlertas]); // ✅ Solo cuando cambie la función

    // ✅ Funciones auxiliares para búsqueda binaria - convertidas a useCallback
    const buscarIndiceInicio = useCallback((array, fechaObjetivo) => {
        let left = 0;
        let right = array.length - 1;
        let resultado = -1;

        while (left <= right) {
            const mid = Math.floor((left + right) / 2);
            if (array[mid].fechaTime >= fechaObjetivo) {
                resultado = mid;
                right = mid - 1;
            } else {
                left = mid + 1;
            }
        }
        return resultado;
    }, []);

    // ✅ Funciones auxiliares para búsqueda binaria - convertidas a useCallback
    const buscarIndiceFin = useCallback((array, fechaObjetivo) => {
        let left = 0;
        let right = array.length - 1;
        let resultado = -1;

        while (left <= right) {
            const mid = Math.floor((left + right) / 2);
            if (array[mid].fechaTime <= fechaObjetivo) {
                resultado = mid;
                left = mid + 1;
            } else {
                right = mid - 1;
            }
        }
        return resultado;
    }, []);

    //Obtiene recorridos por fecha 
    const obtenerRecorridoPorFecha = useCallback((vehiculoUid, fecha_inicio, fecha_fin) => {
        const datosVehiculo = indicesDatos.porVehiculo[vehiculoUid] || [];

        if (!datosVehiculo.length) {
            return { marcadores: [], distancia: 0.0 };
        }

        // DEBUG: Verifica los tipos antes de usar getTime/valueOf
        let fechaInicioTime, fechaFinTime;
        if (fecha_inicio && typeof fecha_inicio.valueOf === "function") {
            fechaInicioTime = fecha_inicio.valueOf();
        } else if (fecha_inicio && typeof fecha_inicio.getTime === "function") {
            fechaInicioTime = fecha_inicio.getTime();
        } else {
            console.error("❌ fecha_inicio inválida:", fecha_inicio);
            return { marcadores: [], distancia: 0.0 };
        }

        if (fecha_fin && typeof fecha_fin.valueOf === "function") {
            fechaFinTime = fecha_fin.valueOf();
        } else if (fecha_fin && typeof fecha_fin.getTime === "function") {
            fechaFinTime = fecha_fin.getTime();
        } else {
            console.error("❌ fecha_fin inválida:", fecha_fin);
            return { marcadores: [], distancia: 0.0 };
        }

        // ✅ Búsqueda binaria para encontrar el rango
        const inicioIndex = buscarIndiceInicio(datosVehiculo, fechaInicioTime);
        const finIndex = buscarIndiceFin(datosVehiculo, fechaFinTime);

        if (inicioIndex === -1 || finIndex === -1) {
            return { marcadores: [], distancia: 0.0 };
        }

        // ✅ Solo procesar el rango encontrado
        let distancia = 0;
        const marcadores = [];

        for (let i = inicioIndex; i <= finIndex; i++) {
            const ubicacion = datosVehiculo[i];
            marcadores.push({
                lat: parseFloat(ubicacion.latitud),
                lng: parseFloat(ubicacion.longitud),
                icon: iconPunto
            });
            distancia += ubicacion.distancia || 0;
        }

        return { marcadores, distancia };
    }, [indicesDatos, buscarIndiceInicio, buscarIndiceFin]);

    // mapear datos del recorrido objeto principal
    const mapearDatos = useCallback((_puntos, lista, filtros) => {

        const listado = (Array.isArray(lista) ? lista : []);
        var nuevaLista = [];
        var fila = null;

        // ✅ Cache para evitar búsquedas repetitivas de vehículos
        const vehiculosCache = new Map();

        listado.forEach((_punto, _indice) => {
            // ✅ Usar cache para vehículos - evita O(n) búsqueda repetitiva
            let vehiculo;
            if (!vehiculosCache.has(_punto.uid_vehiculo)) {
                vehiculo = vehiculosIndexados[_punto.uid_vehiculo];
                vehiculosCache.set(_punto.uid_vehiculo, vehiculo);
            } else {
                vehiculo = vehiculosCache.get(_punto.uid_vehiculo);
            }

            if (!vehiculo) {
                console.warn(`⚠️  Vehículo no encontrado: ${_punto.uid_vehiculo}`);
                return; // Skip este punto si no se encuentra el vehículo
            }

            if (filtros.includes(_punto.tipo_real)) {
                fila = {
                    idunico: _indice,
                    vehiculoId: vehiculo.id,
                    vehiculoUid: vehiculo.value,
                    vehiculo: `${vehiculo.no_economico} / ${vehiculo.alias}`,
                    noEconomico: vehiculo.no_economico,
                    alias: vehiculo.alias,
                    latitudInicio: _punto.latitud,
                    longitudInicio: _punto.longitud,
                    //fechaInicio: dayjs(_punto.fecha).format('YYYY/MM/DD HH:mm:ss'),
                    fechaInicio: dayjs(_punto.fecha).tz(dayjs.tz.guess()).format('YYYY/MM/DD HH:mm:ss'),
                };
            } else {

                if (fila !== null && filtros.includes(_punto.tipo_real) === false) {

                    let fechaFin = new Date(_punto.fecha);
                    //let fechaInicio = new Date(fila.fechaInicio)
                    let fechaInicio = dayjs(fila.fechaInicio, 'YYYY/MM/DD HH:mm:ss').tz(dayjs.tz.guess());
                    const diffMs = fechaFin - fechaInicio; // milisegundos
                    const totalSeconds = Math.floor(diffMs / 1000);
                    const horas = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
                    const minutos = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
                    const tiempo = `${horas}.${minutos} hr(s) `;

                    const marcadorInicial = {
                        lat: parseFloat(fila.latitudInicio),
                        lng: parseFloat(fila.longitudInicio),
                        icon: iconPuntoI
                    };
                    const marcadorFinal = {
                        lat: parseFloat(_punto.latitud),
                        lng: parseFloat(_punto.longitud),
                        icon: iconPuntoF
                    };
                    const { marcadores, distancia } = obtenerRecorridoPorFecha(fila.vehiculoUid, fechaInicio, fechaFin);
                    const km = `${distancia} kms`;

                    fila = {
                        ...fila,
                        latitudFin: _punto.latitud,
                        longitudFin: _punto.longitud,
                        fechaFin: dayjs(fechaFin).format('YYYY/MM/DD HH:mm:ss'),
                        tiempo: tiempo,
                        distancia: distancia,
                        dblTiempo: totalSeconds,
                        dblDistancia: km,
                        track: [
                            marcadorInicial,
                            ...marcadores,
                            marcadorFinal
                        ]
                    };
                    nuevaLista = [...nuevaLista, fila];
                    fila = null;
                }
            }
        });

        if (fila != null && !fila.latitudFin && !fila.longitudFin) {

            let _puntoFinal = _puntos[_puntos.length - 1];
            let fechaFin = dayjs(_puntoFinal.fecha).tz(dayjs.tz.guess());
            let fechaInicio = dayjs(fila.fechaInicio, 'YYYY/MM/DD HH:mm:ss').tz(dayjs.tz.guess());
            const diffMs = fechaFin.valueOf() - fechaInicio.valueOf();
            const totalSeconds = Math.floor(diffMs / 1000);
            const horas = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
            const minutos = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
            const tiempo = `${horas}.${minutos} hr(s)`;

            const marcadorInicial = {
                lat: parseFloat(fila.latitudInicio),
                lng: parseFloat(fila.longitudInicio),
                icon: iconPuntoI
            };
            const marcadorFinal = {
                lat: parseFloat(_puntoFinal.latitud),
                lng: parseFloat(_puntoFinal.longitud),
                icon: iconPuntoF
            };

            const { marcadores, distancia } = obtenerRecorridoPorFecha(fila.vehiculoUid, fechaInicio, fechaFin);
            const distanciaStr = `${distancia} kms`;

            fila = {
                ...fila,
                latitudFin: _puntoFinal.latitud,
                longitudFin: _puntoFinal.longitud,
                fechaFin: dayjs(fechaFin).format('YYYY/MM/DD HH:mm:ss'),
                tiempo: tiempo,
                distancia: distancia,
                dblTiempo: totalSeconds,
                dblDistancia: distanciaStr,
                track: [
                    marcadorFinal,
                    ...marcadores,
                    marcadorInicial,
                ]
            };
            nuevaLista = [...nuevaLista, fila];
            fila = null;
        }
        return nuevaLista;
    }, [vehiculosIndexados, obtenerRecorridoPorFecha]);

    //Obtiene el recorrido para el mapa
    const obtenerRecorrido = useCallback((vehiculoUid) => {
        var marcadores = [];
        var distancia = 0.0;
        if (paginadorRecorridos.datos.length > 0) {
            paginadorRecorridos.datos.sort((a, b) => a.fecha - b.fecha).forEach((_ubicacion, index) => {
                if (vehiculoUid === _ubicacion.vehiculoUid) {
                    marcadores.push({
                        lat: parseFloat(_ubicacion.latitud),
                        lng: parseFloat(_ubicacion.longitud),
                        icon: index === 0 ? iconPuntoI : index === paginadorRecorridos.datos.length - 1 ? iconPuntoF : iconPunto
                    })
                    distancia += _ubicacion.distancia;
                }
            });
        }
        return { marcadores: marcadores, distancia: distancia };
    }, [paginadorRecorridos.datos]); // ✅ Necesita los datos completos para funcionar

    // ✅ CACHE MEMORIZADO PARA RECORRIDOS - Optimizado para evitar re-renders constantes
    const recorridosCache = useMemo(() => {
        const cache = new Map();

        return {
            obtener: (vehiculoUid) => {
                if (!cache.has(vehiculoUid)) {
                    const resultado = obtenerRecorrido(vehiculoUid);
                    cache.set(vehiculoUid, resultado);
                }
                return cache.get(vehiculoUid);
            },
            limpiar: () => cache.clear(),
            tamaño: () => cache.size
        };
    }, [obtenerRecorrido]); // ✅ Solo cuando cambie la función

    //Resetear controles
    const resetearEstadosCompleto = useCallback(() => {
        console.log('🔄 [RESET COMPLETO] Reiniciando todos los estados de progreso');

        // Resetear componentes de carga
        setLoadingComponents({
            table: { loading: false, progress: 0, complete: false },
            vehicles: { loading: false, progress: 0, complete: false },
            alerts: { loading: false, progress: 0, complete: false },
        });

        // Resetear métricas de depuración
        setDebugMetrics(prev => ({
            ...prev,
            searchStartTime: null,
            searchEndTime: null,
            connections: {
                'RecorridosUsabilidad': {
                    ...prev.connections?.['RecorridosUsabilidad'],
                    startTime: null,
                    endTime: null,
                    totalRecordsExpected: 0,
                    totalRecordsReceived: 0,
                    downloadProgress: 0,
                    status: 'pending'
                },
                'AlertasUsabilidad': {
                    ...prev.connections?.['AlertasUsabilidad'],
                    startTime: null,
                    endTime: null,
                    totalRecordsExpected: 0,
                    totalRecordsReceived: 0,
                    downloadProgress: 0,
                    status: 'pending'
                }
            },
            globalTotalRecordsExpected: 0,
            globalTotalRecordsReceived: 0,
            globalDownloadProgress: 0,
            activeConnections: 0
        }));

        // Limpiar stores
        store.editarListaReporte([]);
        store.editarListaTabla([]);
        editarAlertasRecorrido([]);
        editarTotalCarga([]);

        // Limpiar paginadores
        paginadorRecorridos.editarDatos([]);
        paginadorRecorridos.editarProgresoCargado(0);
        paginadorAlertas.editarDatos([]);
        paginadorAlertas.editarProgresoCargado(0);
    }, [store, paginadorRecorridos, paginadorAlertas]);

    /****** Eventos (Effect) ************************************/
    useEffect(() => {
        let alertas = (Array.isArray(paginadorAlertas.datos) ? paginadorAlertas.datos : []);
        if (alertas.length > 0) {
            // ✅ Solo logear, no forzar progreso (se maneja desde updateDebugMetrics)
            console.log(`✅ [Alerts] Datos procesados: ${alertas.length} registros`);
        } else {
            // ✅ MANEJAR CASO SIN DATOS DE ALERTAS
            console.log('⚠️ [Alerts] No hay datos de alertas disponibles');
        }
    }, [paginadorAlertas.datos, updateComponentProgress]);

    //Obtiene el icono de la alerta 
    const obtenerIcono = (tipoAlerta) => {

        var icono = obtenerIconoEvento(tipoAlerta);

        const src = icono?.props?.src;
        return icono;
    };

    //Evento para limpar el componente
    useEffect(() => {
        // ✅ LIMPIAR ESTADOS AL ENTRAR AL COMPONENTE
        const limpiarEstadosAlEntrar = () => {
            console.log('🧹 Limpiando estados al entrar al reporte');

            // Limpiar paginadores
            paginadorRecorridos.editarDatos([]);
            paginadorRecorridos.editarProgresoCargado(0);
            paginadorRecorridos.editarCargando(false);

            // Si hay otros paginadores
            if (paginadorAlertas) {
                paginadorAlertas.editarDatos([]);
                paginadorAlertas.editarProgresoCargado(0);
                paginadorAlertas.editarCargando(false);
            }


            // Limpiar stores específicos si existen
            if (store?.editarListaReporte) {
                store.editarListaReporte([]);
                store.editarListaTabla([]);
            }
        };

        // Ejecutar limpieza al montar
        limpiarEstadosAlEntrar();

        // Cleanup al desmontar
        return () => {
            console.log('🧹 Limpiando estados al salir del reporte');
            limpiarEstadosAlEntrar();
        };
    }, []);

    //Peticion Servicio API Recorridos
    useEffect(() => {
        if (paginadorRecorridos.cargando === false && filtrosLocal !== null) {
            // ✅ ESTABLECER TIEMPO DE INICIO AL COMENZAR LA BÚSQUEDA
            setDebugMetrics(prev => ({
                ...prev,
                searchStartTime: Date.now(),
                searchEndTime: null
            }));

            // ✅ MARCAR COMPONENTE COMO CARGANDO AL INICIAR DESCARGA
            setLoadingComponents(prevState => ({
                ...prevState,
                vehicles: { loading: true, progress: 0, complete: false }
            }));

            //updateComponentProgress('vehicles', 5, false);

            cargarPaginasUltraOptimizado(
                ApiRecorridos,
                paginadorRecorridos,
                filtrosLocal,
                connectionId,
                null,
                (updates) => {
                    updateDebugMetrics({ ...updates, connectionId });

                    if (updates.downloadProgress) {
                        updateComponentProgress('vehicles', updates.downloadProgress * 0.8, false);
                    }
                }
            );

        }
        if (paginadorAlertas.cargando === false && filtrosLocal !== null) {
            // ✅ ESTABLECER TIEMPO DE INICIO SI NO ESTÁ YA ESTABLECIDO
            setDebugMetrics(prev => ({
                ...prev,
                searchStartTime: prev.searchStartTime || Date.now(),
                searchEndTime: null
            }));

            // ✅ MARCAR COMPONENTE COMO CARGANDO AL INICIAR DESCARGA
            setLoadingComponents(prevState => ({
                ...prevState,
                alerts: { loading: true, progress: 0, complete: false }
            }));

            //updateComponentProgress('alerts', 5, false);

            cargarPaginasUltraOptimizado(
                apialertas,
                paginadorAlertas,
                filtrosLocal,
                conectionidalertas,
                null,
                (updates) => {
                    updateDebugMetrics({ ...updates, connectionId });

                    if (updates.downloadProgress) {
                        updateComponentProgress('alerts', updates.downloadProgress * 0.8, false);
                    }
                }
            );
        }
    }, [filtrosLocal, updateComponentProgress, updateDebugMetrics]);

    //Procesa y mapea la data para la tabla de datos
    useEffect(() => {
        let datos = (Array.isArray(paginadorRecorridos.datos) ? paginadorRecorridos.datos : []);
        if (datos.length > 0) {
            // ✅ Solo actualizar si no está completando la descarga (>= 100%)
            setLoadingComponents(prevState => {
                const currentProgress = prevState.vehicles?.progress || 0;
                if (currentProgress < 100) {
                    // Solo procesar datos después de descarga completa
                    console.log(`🔄 [Vehicles] Procesando datos descargados (${datos.length} registros)`);
                    return prevState;
                }
                return prevState;
            });

            let data = datos.map(w => (
                {
                    "tipo_real": `${w.tipo}`,
                    "alerta_real": w.nombreEvento,
                    "icono_alerta": "",
                    "fecha": w.fecha,//w.fechacliente,
                    "fecha_ticks": w.fechaInt,
                    "latitud": w.latitud,
                    "longitud": w.longitud,
                    "chofer": "",
                    "cliente": "",
                    "geoceca": "",
                    "referencia": "",
                    "no_economico": w.vehiculos.noEconomico,
                    "id_vehiculo": 0,
                    "direccion": "",
                    "uid_vehiculo": w.vehiculos.vehiculoUid,
                    "uid_vehiculo_externo": "",
                    "id_camara": "",
                    "vehiculo_con_camara": false,
                    "camara_en_linea": false,
                    "camara_elemento": "div",
                    "camara_api_grupo": null,
                    "extras_alertas_quro": {},
                    "extras_alertas_ia": {},
                    "extras_alertas_omisiones": {
                        "alerta": "",
                        "evento": "",
                        "riesgo": "",
                        "mensaje": "",
                        "velocidad": 0,
                        "distancia": 0,
                        "odometro": 0,
                        "tipo_motor": 0,
                        "tiempo": 0,
                        "tipo_marcado": 0,
                        "veces": 0
                    },
                    "tipo_alerta": w.tipo,
                    "alerta": w.nombreEvento
                }

            ));
            editarAlertasRecorrido(data);
            console.log(`✅ [Vehicles] Datos procesados: ${data.length} registros convertidos`);
        }
    }, [paginadorRecorridos.datos, updateComponentProgress]);

    //Evento para procesar informacion de el reporte de horas no laborales 
    useEffect(() => {

        if (
            !alertasRecorrido.length ||
            paginadorRecorridos.cargando ||
            paginadorAlertas.cargando ||
            !paginadorRecorridos.datos.length
        ) return;

        // ✅ MANEJAR CASO ESPECIAL: Alertas vacías pero vehículos con datos
        if (!paginadorAlertas.datos.length) {
            console.log('⚠️ [HorarioNoLaboral] No hay alertas disponibles, finalizando progreso...');
            updateComponentProgress('table', 100, true);
            updateComponentProgress('alerts', 100, true);
            updateComponentProgress('vehicles', 100, true);
            return;
        }

        if (selectedVehicle === null) {
            // updateComponentProgress('table', 10, false);
        }

        const generarReporte = async () => {
            console.log('🔄 Iniciando generación de reporte optimizada...');
            const startTime = performance.now();

            if (selectedVehicle === null) {
                // updateComponentProgress('table', 30, false);
            }

            // ✅ OPTIMIZACIÓN: Agrupar alertas por vehículo usando reduce optimizado
            var _agrupadoPorVehiculo = alertasRecorrido.reduce((acc, record) => {
                if (!record.uid_vehiculo) return acc; // Skip si no tiene uid_vehiculo

                const vehiculoId = record.uid_vehiculo;
                if (!acc[vehiculoId]) {
                    const vehiculo = vehiculosIndexados[vehiculoId];
                    acc[vehiculoId] = {
                        vehiculo: vehiculo?.no_economico || record.no_economico,
                        vehiculoId: vehiculoId,
                        detalle: []
                    };
                }
                acc[vehiculoId].detalle.push(record);
                return acc;
            }, {});

            // Convertir a array y ordenar
            _agrupadoPorVehiculo = Object.values(_agrupadoPorVehiculo)
                .sort((a, b) => a.vehiculoId.localeCompare(b.vehiculoId));

            console.log(`✅ Agrupación completada: ${_agrupadoPorVehiculo.length} vehículos en ${performance.now() - startTime}ms`);

            var _adTemp = [];
            var _aeTemp = [];
            var _dTemp = [];

            if (_agrupadoPorVehiculo.length > 0) {
                // ✅ OPTIMIZACIÓN: Procesar en lotes para no bloquear UI
                for (let i = 0; i < _agrupadoPorVehiculo.length; i++) {
                    const _grupo = _agrupadoPorVehiculo[i];
                    var _puntos = _grupo.detalle.sort((a, b) => dayjs(a.fecha) - dayjs(b.fecha));

                    try {
                        // Procesar alertas de detenidos
                        _adTemp.push(...mapearDatos(_puntos, _puntos, adTipos));

                        // Procesar encendidos/apagados
                        var ae = [
                            ..._puntos.filter(w => eTipos.includes(w.tipo_real)),
                            ..._puntos.filter(w => aTipos.includes(w.tipo_real)),
                        ].sort((a, b) => dayjs(a.fecha) - dayjs(b.fecha));
                        _aeTemp.push(...mapearDatos(_puntos, ae, eTipos));

                        // Procesar detenidos
                        _dTemp.push(...mapearDatos(_puntos, _puntos, dTipos));

                    } catch (error) {
                        console.error(`Error procesando vehículo ${_grupo.vehiculoId}:`, error);
                    }

                    // ✅ Dar un respiro al navegador cada 10 vehículos
                    if (i % 10 === 0 && i > 0) {
                        await new Promise(resolve => setTimeout(resolve, 0));
                    }
                }

                console.log(`✅ Mapeo completado: ${_adTemp.length + _aeTemp.length + _dTemp.length} registros procesados`);

                var mergedAlerts = [];
                let listTypeAlerts = (Array.isArray(_adTemp) ? _adTemp : []);
                let listTypeIgnitions = (Array.isArray(_aeTemp) ? _aeTemp : []);
                let listStopsType = (Array.isArray(_dTemp) ? _dTemp : []);

                // ✅ OPTIMIZACIÓN: Pre-calcular función de horarios una sola vez
                let comprobarHorario = (horarios, fecha) => {
                    var dia = (dayjs(fecha).day() - 1);
                    dia = dia >= 0 ? dia : 6
                    let hora = dayjs(fecha).hour() + '';
                    let hrs = horarios?.[dia]?.horas;
                    return hrs && hrs.includes(hora);
                };

                // ✅ OPTIMIZACIÓN: Merge usando spread optimizado
                if (listTypeAlerts.length > 0) {
                    mergedAlerts.push(...listTypeAlerts.map(item => ({ ...item, TypeReport: 0 })));
                }
                if (listTypeIgnitions.length > 0) {
                    mergedAlerts.push(...listTypeIgnitions.map(item => ({ ...item, TypeReport: 1 })));
                }
                if (listStopsType.length > 0) {
                    mergedAlerts.push(...listStopsType.map(item => ({ ...item, TypeReport: 2 })));
                }

                /*PARA HORARIOS SE OBTENDRA LOS DIAS QUE SE ESTAN FILTRANDO*/
                const diasSeleccionados = [];
                const dia_inicio = new Date(store.fechaInicio);
                const dia_fin = new Date(store.fechaFin);
                while (dia_inicio <= dia_fin) {
                    diasSeleccionados.push(dia_inicio.getDay());
                    dia_inicio.setDate(dia_inicio.getDate() + 1);
                }
                var countHorarios = 0;

                // ✅ OPTIMIZACIÓN: Usar vehiculosIndexados en lugar de buscar
                let vehiculosConHorarios = Object.keys(vehiculosIndexados).reduce((acc, vehiculoKey) => {
                    const record = vehiculosIndexados[vehiculoKey];
                    const key = record.value;

                    if (!acc[key]) {
                        acc[key] = {
                            ...record,
                            AllHours: 0,
                        };
                    }

                    acc[key].AllHours = 0;
                    const horarioV = (Array.isArray(record.horario_vehiculo) ? record.horario_vehiculo : []);
                    const horarioE = (Array.isArray(record.horario_empresa) ? record.horario_empresa : []);

                    if (horarioV.length > 0) {
                        countHorarios += 1;
                    }

                    if (horarioV.length !== 0 || horarioE.length !== 0) {
                        var horarios = horarioV.length !== 0 ? horarioV : horarioE;

                        horarios = diasSeleccionados.map(diaSeleccionado => {
                            return horarios.find(w => w.dia === diaSeleccionado);
                        });

                        horarios.forEach((horario) => {
                            if (horario !== undefined) {
                                horario.horas.split(',').forEach(() => {
                                    acc[key].AllHours++;
                                });
                            }
                        });

                        // Si no hay horarios definidos para ningún día, asigna 24 horas por día
                        if (acc[key].AllHours === 0) {
                            acc[key].AllHours = 24 * diasSeleccionados.length;
                        }

                    } else {
                        acc[key].AllHours = 24 * diasSeleccionados.length;
                    }

                    return acc;
                }, {});

                // ✅ SOLO LLAMAR A store.editarVehiculoSinHorario SI EL VALOR CAMBIÓ
                if (store.vehiculoSinHorario !== countHorarios) {
                    store.editarVehiculoSinHorario(countHorarios);
                }

                console.log(`✅ Vehículos con horarios: ${Object.keys(vehiculosConHorarios).length}, Total Horas: ${countHorarios}`);

                let estaDentroHorario = (item) => {
                    let veh = vehiculosConHorarios[item.vehiculoUid];
                    if (!veh) return false;

                    const horarioV = (Array.isArray(veh.horario_vehiculo) ? veh.horario_vehiculo : []);
                    const horarioE = (Array.isArray(veh.horario_empresa) ? veh.horario_empresa : []);
                    let horarios = horarioV.length > 0 ? horarioV : horarioE;
                    return comprobarHorario(horarios, item.fechaInicio) && comprobarHorario(horarios, item.fechaFin);
                }

                // ✅ OPTIMIZACIÓN: Filtrar una sola vez y usar cache para recorridos
                let groupedAlerts = mergedAlerts
                    .filter(w => w.TypeReport === store.tipoVista.value)
                    .reduce((acc, record, index) => {
                        const key = record.vehiculoUid;

                        if (!acc[key]) {
                            acc[key] = {
                                ...record,
                                color: 'success',
                                tipo_vista: store.tipoVista.value,
                                children: [],
                                totalTiempo: 0,
                                totalKM: 0,
                                markers: [],
                                track: [],
                                fueraDeHorario: false,
                            };
                        }

                        // ✅ USAR CACHE para recorridos en lugar de recalcular
                        const recorridoData = recorridosCache.obtener(key);
                        const marcadoresAlertas = marcadoresAlertasCache.obtener(key);

                        let newChild = {
                            ...record,
                            color: acc[key].color,
                            tipo_vista: acc[key].tipo_vista,
                            fueraDeHorario: !estaDentroHorario(record)
                        };

                        acc[key].totalKM = recorridoData.distancia;
                        acc[key].fechaInicio = record.fechaInicio;
                        acc[key].fechaFin = record.fechaFin;
                        acc[key].tiempo = '';
                        acc[key].distancia = '';

                        if (acc[key].children.length === 0) {
                            acc[key].children.push({ ...newChild, header: true });
                        }

                        if (newChild.fueraDeHorario === true) {
                            acc[key].totalTiempo += (parseFloat(record.dblTiempo) / 3600);
                            acc[key].children.push(newChild);
                        }

                        acc[key].markers = marcadoresAlertas;
                        acc[key].track = recorridoData.marcadores;
                        acc[key].fueraDeHorario = newChild.fueraDeHorario === true ? true : acc[key].fueraDeHorario;

                        return acc;
                    }, {});

                const vehiculosEnTabla = new Set(Object.keys(groupedAlerts));

                // ✅ OPTIMIZACIÓN: Reducir en una sola pasada usando Object.values
                let listaReporte = Object.values(groupedAlerts).reduce((acc, record) => {

                    const key = record.vehiculoUid;
                    let v = vehiculosConHorarios[key];

                    if (!v) return acc; // Skip si no se encuentra el vehículo
                    if (!vehiculosEnTabla.has(key)) return acc;
                    if (record.children.length <= 1) return acc;

                    if (!acc[key]) {
                        acc[key] = {
                            title: record.vehiculo,
                            tipo_vehiculo: v.tipo_vehiculo,
                            color_vehiculo: v.color_vehiculo,
                            totalRecords: 0,
                            totalTime: 0,
                            totalAlerts: 0,
                            totalDistance: 0,
                            totalIgnition: 0,
                            totalStopped: 0,
                            totalOff: 0,
                            totalLitters: 0,
                            AllHours: horas,
                        };
                    }

                    acc[key].AllHours = v.AllHours;

                    //Recorremos los hijos que son el recorrido
                    record.children.forEach(subitem => {

                        if (subitem.fueraDeHorario === true) {
                            if (subitem.TypeReport === 0) {
                                acc[key].totalAlerts++;
                            }

                            if (subitem.TypeReport === 1) {
                                acc[key].totalTime += parseFloat((parseFloat(subitem.dblTiempo) / 3600));
                                acc[key].totalDistance += parseFloat(subitem.dblDistancia);
                            }

                            if (subitem.TypeReport === 0 || subitem.TypeReport === 2) {
                                acc[key].totalStopped += parseFloat((parseFloat(subitem.dblTiempo) / 3600));
                            }

                            acc[key].totalRecords++;
                        }

                    });


                    return acc;
                }, {});

                // ✅ OPTIMIZACIÓN: Pre-filtrar alertas por vehículo para evitar filter repetido
                const alertasPorVehiculoFiltradas = paginadorAlertas.datos.reduce((acc, alert) => {
                    const key = alert.uid_vehiculo;
                    if (!acc[key]) acc[key] = [];

                    let alerta = alertasIndexadas[alert.alerta?.toLowerCase()];
                    let titulo = alerta?.alertas?.find(item => item.tipo_alerta === parseInt(alert.tipo_real))?.titulo;
                    let vehiculo = vehiculosIndexados[alert.uid_vehiculo];

                    acc[key].push({
                        ...alert,
                        alerta_titulo: titulo,
                        no_economico: vehiculo ? (vehiculo.no_economico + " / " + vehiculo.alias) : ''
                    });
                    return acc;
                }, {});

                let listaTabla = Object.values(groupedAlerts).map((item) => {
                    const key = item.vehiculoUid;
                    let dataReporte = listaReporte[key];

                    if (!dataReporte) return null; // Skip si no hay data

                    let vehiculoFind = store.vehiculos.filter(w => w.value === item.vehiculoUid);

                    const horario = dataReporte.AllHours.toFixed(0);
                    const minutosEncendido = (dataReporte.totalTime);
                    const minutosDetenido = (dataReporte.totalStopped);
                    const minutosTotales = (minutosEncendido);
                    var minutosApagado = (dataReporte.totalOff);
                    const calculatedOffs = ((horario) - minutosTotales);
                    if (!isNaN(calculatedOffs)) {
                        if (calculatedOffs > 0) {
                            minutosApagado = calculatedOffs;
                        }
                    }

                    const tiempo = String(Math.floor(minutosTotales)).padStart(2, '0')
                        + '.'
                        + String(Math.floor((minutosTotales * 60) % 60)).padStart(2, '0')
                        + ' hr(s) ';

                    return {
                        ...item,
                        usabilidad: Math.round((minutosTotales / horario) * 100),
                        horas: horario,
                        tiempoEncendido: minutosEncendido,
                        tiempoDetenido: minutosDetenido,
                        tiempoApagado: minutosApagado,
                        tiempo: tiempo,
                        distancia: dataReporte.totalDistance,
                        totalAlertas: alertasPorVehiculoFiltradas[key] || [],
                        chofer: 'N/A',
                        tipo_vehiculo: vehiculoFind.tipo_vehiculo,
                        color_vehiculo: vehiculoFind.color_vehiculo
                    };
                }).filter(Boolean) // Remover nulls
                    .sort((a, b) => b.usabilidad - a.usabilidad);

                //Filtrado por vehiculo seleccionado fuera de horario
                let filteredTableData = listaTabla.filter(w => w.children.length > 1);

                if (selectedVehicle) {
                    filteredTableData = listaTabla.filter(w => w.vehiculo === selectedVehicle);
                }

                store.editarListaReporte(listaReporte);
                store.editarListaTabla(filteredTableData);

                console.log(`✅ Reporte generado: ${listaTabla.length} vehículos en ${performance.now() - startTime}ms`);
                console.log(`📊 Cache stats - Recorridos: ${recorridosCache.tamaño()}, Marcadores: ${marcadoresAlertasCache.tamaño()}`);
            }

            if (selectedVehicle === null) {
                //updateComponentProgress('table', 60, false); // ✅ Progreso intermedio
            }

            const porcentajeFinal = paginadorRecorridos.progresoCargado / 2;
            editarTotalCarga([
                {
                    title: 'Total de reporte cargado',
                    percent: porcentajeFinal,
                    color: "#c00f1b",
                    animated: true
                },
            ]);

            updateComponentProgress('table', 100, true); // ✅ Completar tabla
            updateComponentProgress('alerts', 100, true); // ✅ Completar alerts
            updateComponentProgress('vehicles', 100, true);

            // ✅ GARANTIZAR FINALIZACIÓN EN TODOS LOS CASOS
            setDebugMetrics(prev => ({
                ...prev,
                searchEndTime: Date.now()
            }));
        };

        generarReporte();
    }, [
        selectedVehicle,
        alertasRecorrido,
        paginadorRecorridos.cargando,
        paginadorAlertas.cargando,
        paginadorRecorridos.datos,
        paginadorAlertas.datos,
        updateComponentProgress
    ]);

    //Evento para generar el reporte en formato PDF
    useEffect(() => {
        if (!window.printReportModule) {
            window.printReportModule = new PrintReportModule({
                captureQuality: 0.95,
                pdfFormat: 'A4',
                pdfOrientation: 'landscape',
                useNativeTables: true,
                maxRowsPerPage: 30,
                tableFontSize: 7,

                // ✅ CONFIGURACIÓN ESPECÍFICA PARA KILOMETRAJE
                reportType: 'tiempos',
                captureContainer: '#reporte-tiempos-content',

                tableExtractionConfig: {
                    enabled: true,
                    selector: '#tabla-tiempos',
                    title: 'Listado de tiempos',
                    type: 'html', // html, tanstack, dual-table
                    headerSelector: 'thead th, thead td',
                    bodySelector: 'tbody tr',
                    cellSelector: 'td',
                    // ✅ Transformaciones opcionales
                    cellTransforms: {
                        'button[class*="btn"]': 'Ver Mapa',
                        '.fa-map-marker-alt': 'Ver Ubicación'
                    }
                },

                // 📊 ESTRATEGIA HORIZONTAL: Capturar por filas (recomendado para landscape)
                horizontalStrategy: 'rows',
                horizontalRows: [
                    {
                        title: 'Resumen y Gráfico de tiempos',
                        selector: '.g-3:first-of-type', // Primera fila con las dos cards
                        identifier: 'kilometraje-fila-1',
                        selectorMethod: 'direct'
                    },

                ],

                // 📱 ESTRATEGIA VERTICAL: Capturar targets individuales (para portrait)
                verticalStrategy: 'targets',
                captureTargets: [
                    {
                        title: 'Resumen de tiempos',
                        selector: '#card-tiempos',
                        type: 'card'
                    },

                ]
            });
        }

        return () => {
            if (window.printReportModule) {
                delete window.printReportModule;
            }
        };
    }, []);

    //Evento Carga load
    useEffect(() => {
        setMaxProgress(Math.round(debugMetrics.globalDownloadProgress || 0));
    }, [debugMetrics.globalDownloadProgress]);

    /**** Configuracion Renderizado dinamico *******************************************/
    const renderContent = () => {

        // 1. Estado inicial - no se ha iniciado búsqueda
        if (!searchInitiated) {
            return <WelcomeEmptyState reportType="horario no laboral" />;
        }

        // 2. Errores de validación
        if (validationError) {
            return (
                <ValidationError
                    message={validationError}
                    onClose={() => setValidationError(null)}
                />
            );
        }

        // 3. Errores de API
        if (apiError) {
            return (
                <APIError
                    message={apiError}
                    onRetry={() => {
                        setApiError(null);
                        // Reintentar con los filtros actuales
                        if (filtrosLocal) {
                            onGenerateReport(filtrosLocal);
                        }
                    }}
                    onClose={() => setApiError(null)}
                />
            );
        }

        // 4. Sin filtros seleccionados
        if (hasNoFiltersSelected()) {
            return <NoSelectionEmptyState reportType="horario no laboral" />;
        }

        // 5. Estado de carga
        if (isLoadingData()) {

            console.log('isLoadingData=' + isLoadingData())
            return <LoadingEmptyState reportType="horario no laboral" />;
        }

        // 6. Sin datos encontrados
        if (hasNoData()) {
            return <NoDataEmptyState reportType="horario no laboral" />;
        }

        // 7. Mostrar contenido con datos
        return (
            <div id="reporte-tiempos-content" data-report-area="tiempos">
                <Row className="g-3 mb-3">
                    <Col md={12} xs={12}>
                        <div id="card-tiempos" style={{ height: '350px' }}>
                            <CardVehiclesOutHour
                                onSelectVehicle={handleSelectVehicle}
                                highlightedVehicle={selectedVehicle}
                                handleCleanFilters={handleClearFilters}
                            />
                        </div>
                    </Col>
                </Row>

                <Col md={12}>
                    <div id="tabla-tiempos">
                        <TableNonWorkingHours
                            data={store.listaTabla}
                            title="Listado de vehiculos fuera de horario laboral"
                            isGroup={true}
                            geocercas={geocercas || []}
                            searchValue={searchValue}
                            onSearch={setSearchValue}
                            pageSize={perPage}
                            selectedVehicle={selectedVehicle}
                        />
                    </div>
                </Col>
            </div>
        );
    };

    /******* Renderizar el componente principal ***************************************/
    return (
        <div>
            <div className="m-3">
                <Row>
                    <Col md={10}>
                        <h4 className="mt-2">Horario no laboral</h4>
                    </Col>
                </Row>
            </div>

            <Card className="p-3 mb-3 mt-3">

                <hr className="text-danger" />

                <FiltersNonWorkingHours
                    onGenerateReport={onGenerateReport}
                    imprimir={!filtrosLocal ? false : !paginadorRecorridos.cargando}
                    onToggleDebug={() => setShowDebugPanel(!showDebugPanel)} // ✅ Nuevo prop
                />

                {/* Progress Bar; barra de progreso en la carga de informacion */}
                <Col md={12}>
                    <StandardProgressBar
                        calculateTotalProgress={calculateTotalProgress}
                        debugMetrics={debugMetrics}
                    />
                </Col>

            </Card>

            {/** Renderizado Dinamico *****************/}
            {renderContent()}
        </div>
    );
}

export default ReporteHorarioNoLaboral;